import React from 'react';
import BreadcrumbItem from './BreadcrumbItem';
import { Breadcrumb } from 'models/interfaces';
import { FolderIcon } from '../Icons/BreadcrumbIcons';

interface BreadcrumbListProps {
  breadcrumbs: [Breadcrumb];
}
const BreadcrumbList: React.StatelessComponent<BreadcrumbListProps> = ({ breadcrumbs }) => {
  const crumbStack = Object.keys(breadcrumbs).length ===0 ? null: breadcrumbs.map((c, i) => (
    <BreadcrumbItem key={`${c.name} - ${i}`} crumb={c} index={i} />
  ));
  return (
    <ol className="breadcrumbs">
      <span style={{ marginRight: '0.5rem' }}>
        <FolderIcon />
      </span>
      {crumbStack}
    </ol>
  );
};

export default BreadcrumbList;
